import Svg, { SvgProps, Path } from 'react-native-svg';

const ServingZoneIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 2a8 8 0 0 0-8 8c0 6 7 8 7 12a1 1 0 0 0 2 0c0-4 7-6 7-12a8 8 0 0 0-8-8zm0 6a2 2 0 1 1 .001 3.999A2 2 0 0 1 15 8zm-9 9c-.417 0-.79.26-.938.648l-3 8A1.001 1.001 0 0 0 3 27h24a1 1 0 0 0 .938-1.352l-3-8A1.003 1.003 0 0 0 24 17h-1.977a37.94 37.94 0 0 1-1.646 1.697c-.105.102-.206.203-.307.303h3.237l2.25 6H4.443l2.25-6H9.93l-.305-.303A37.405 37.405 0 0 1 7.977 17H6z" />
  </Svg>
);

export default ServingZoneIcon;
